import { render, staticRenderFns } from "./silderV.vue?vue&type=template&id=592688fc&scoped=true"
import script from "./silderV.vue?vue&type=script&lang=js"
export * from "./silderV.vue?vue&type=script&lang=js"
import style0 from "./silderV.vue?vue&type=style&index=0&id=592688fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592688fc",
  null
  
)

export default component.exports